export const useColumnPositionTop = (
	columnsWrapperRef: React.RefObject<HTMLDivElement>
): string | undefined => {
	if (columnsWrapperRef.current) {
		return columnsWrapperRef.current.getBoundingClientRect().top + 'px'
	}
	return undefined
}
